// Adding a secret, replacing its value and deleting it: the drawer, its fields and choices.
import type { ReactNode } from "react";

import { rich } from "../../../helpers";

export default {
  signedBy: (device: string) => `Signed by ${device}`,
  add: {
    title: "Add a secret",
    newOf: (template: string) => `New ${template}`,
    pick: "Pick what it is. The template sets the fields and where the broker may use it.",
    name: "Name",
    nameHint: "Unique in the organisation. Runs refer to it by this name.",
    scopeLabel: (scope: string) => `${scope} it may be used for (optional)`,
    scopeHint: "The broker refuses any other target.",
    hosts: "Allowed hosts",
    header: "Header template",
    sealedNote:
      "The value is encrypted in this browser to the platform daemon's key before it is sent, and the request is signed with this browser's device key.",
    save: "Save secret",
  },
  value: {
    help: "Write-only. Sealed in this browser; never shown again, only replaced.",
    placeholder: "Paste it once",
  },
  kept: {
    legend: "Kept",
    server: "On the server",
    serverHelp: "Encrypted; the broker opens it per call",
    devices: "On my devices",
    soon: "Soon",
    devicesHelp: "Released to a run when you approve it",
  },
  agentReadable: {
    label: "The agent can read this",
    off: "Off: the broker uses it for the agent, which never sees it.",
    warning:
      "The value is written into each run's memory-only filesystem. A prompt-injected agent, or anything it installs, could print or send it. Use this only for tools that must hold the secret themselves. Every run that receives it is audited.",
  },
  replace: {
    title: (name: string) => `Replace ${name}`,
    form: (name: string) => `Replace the value of ${name}`,
    lead: "The old value is overwritten; runs pick up the new one on their next use. The name, scope and settings stay as they are.",
    save: "Save new value",
    jiraUpgrade: "This Jira secret holds only a token. Give its site URL and email too: Jira Cloud needs both, and the secret is converted when you save."
  },
  edit: {
    title: (name: string) => `Edit ${name}`,
    form: (name: string) => `Edit ${name}`,
    valueTitle: "Value",
    valueBody: "Write-only: it is never shown. Replace it to rotate it or to change its fields.",
    replaceValue: "Replace value",
    save: "Save changes",
    nameRequired: "Give the secret a name.",
    hostsRequired: "List at least one allowed host.",
    headerRequired: "Give a header template, for example Authorization: Bearer {value}.",
  },
  remove: {
    label: (name: string) => `Delete ${name}?`,
    question: (name: ReactNode) => rich("Delete ", name, "?"),
    body: "Runs that use it fail at their next broker call. The request is signed by this browser and cannot be undone.",
    confirm: (name: string) => `Confirm delete ${name}`,
  },
  sealingKeyMismatch: (id: string) => `the sealing key does not match its id ${id}`,
};
